import { IconSvgElement } from "@hugeicons/react";

export enum PromoFeatureName {
  // snake_case for better sync with PostHog Person Properties naming
  CombinedIncome = "combined_income",
  ChatMovedToInbox = "chat_moved_to_inbox"
}

export enum PromoSize {
  XS = "XS",
  SM = "SM",
  BASE = "BASE"
}

export enum PromoFeatureFlag {
  Modal = "show-promo-modal",
  Banner = "show-promo-banner"
}

export enum PromoType {
  Modal = "modal",
  Banner = "banner"
}

// Why the promo was closed — "action" means the user clicked the action button,
// which dismisses permanently, while "close" may only step down to the banner.
export type PromoCloseReason = "close" | "action";

export type PromoContent = {
  actionButtonTitle: string;
  // External link, opened in a new tab.
  actionButtonLink?: string;
  // In-app route, navigated to after the promo closes.
  actionButtonRoute?: string;
  closeButtonTitle?: string;
  imageSrc?: string;
  icons?: {
    src: string;
    alt: string;
    width?: number;
    height?: number;
    classNames?: string;
  }[];
  title?: string;
  subtitle?: string;
  description?: string;
  bulletPoints?: string[];
  bulletIcon?: IconSvgElement;
  // Both override the size preset widths when set.
  onCloseClassNames?: string;
  actionButtonClassNames?: string;
};

export type PromoContentComponentProps = {
  size: PromoSize;
  onClose?: () => void;
  onActionButtonClick?: () => void;
  featureName: PromoFeatureName;
  promoType: PromoType;
  contentOverrides?: Partial<PromoContent>;
};

export type PromoShouldApplyData = {
  isBoomScreen: boolean;
  partnerCreatedAt?: string;
  featureFlagEnabled?: boolean;
  sessionPromoData: string | null;
  // Chat -> Inbox promo only: audience gate plus its persisted display state.
  isChatInboxAudience?: boolean;
  modalSeen?: boolean;
  dismissed?: boolean;
};
